<div class="row" [formGroup]="parent">
  <ng-container formGroupName="orderHeader">
    <div class="col">
      <jni-header-customer-account
        [parent]="parent"
        [deliveryAddress]="deliveryAddress"
        (customerBillToObjectEvent)="getCustomerBillToData($event)"
        (smallLoaderEvent)="getLoaderStatus($event)"
        [formErrors]="formErrors"
        (validationErrorEvent)="logValidationErrors()"
        (clearShipToEvent)="clearShipToForm()"
        (bcSelectionForProspectEvent)="bcSelectionForProspects($event)"
        (getAllBuyersIfClientAccountEvent)="
          getAllBuyersIfClientAccountEvent($event)
        "
        (selectedClientCurrenyEvent)="patchValueInCurrencyFieldEvent($event)">
      </jni-header-customer-account>
    </div>
    <div class="col">
      <jni-buyer
        #buyer
        [parent]="parent"
        [deliveryAddress]="deliveryAddress"
        (smallLoaderEvent)="getLoaderStatus($event)"
        [formErrors]="formErrors"
        (validationErrorEvent)="logValidationErrors()"
        (clearShipToEvent)="clearShipToForm()"
        (customerBillToObjectEvent)="getCustomerBillToData($event)"
        (getBuyerEvent)="getAllBuyers()">
      </jni-buyer>
    </div>
    <div
      *ngIf="customerBillToObject?.clientAccount"
      class="d-flex justify-content-start pb-1 col add-btn"
      (click)="addContactInformation()">
      <a class="d-flex align-items-center"><i class="pi pi-plus"></i>Add</a>
    </div>
    <div class="col">
      <div class="form-group has-float-label">
        <label class="form-label"
          >Job name<span class="madatory-field">*</span></label
        >
        <input
          pInputText
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          formControlName="jobName"
          [ngClass]="{ 'has-error': formErrors['jobName'] }"
          (blur)="logValidationErrors()" />

        <span class="error-msg" *ngIf="formErrors['jobName']">
          {{ formErrors["jobName"] }}
        </span>
      </div>
    </div>
    <div class="col-auto d-flex gap-2">
      <div class="form-group has-float-label d-flex justify-content-center">
        <div class="d-flex gap-2 align-items-end">
          <p-radiobutton
            class="me-2"
            name="type"
            formControlName="type"
            value="OneTime"
            (change)="onTempleteSelection('OneTime')" />

          <label for="ny" class="ml-2">One Time</label>
        </div>
      </div>
      <div class="form-group has-float-label d-flex justify-content-center">
        <div class="d-flex gap-2 align-items-end">
          <p-radiobutton
            class="me-2"
            name="type"
            formControlName="type"
            value="templete"
            (change)="onTempleteSelection('templete')" />

          <label for="ny" class="ml-2">Template</label>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-group has-float-label">
        <!-- <input pInputText 
          jniAutoCompleteBlocker
          class="form-control"
          [min]="shipDateCurrentdate | date: 'yyyy-MM-dd'"
          (change)="onShipDateSelection($event)"
          onfocus="(this.type='date')"
          onblur="if(!this.value) this.type='text'"
        /> -->
        <label class="form-label">Ship date</label>
        <p-date-picker
          jniAutoCompleteBlocker
          inputId="basic"
          class="date-input"
          formControlName="shipDate"
          (onSelect)="onShipDateSelection($event)"
          [minDate]="shipDateCurrentdate"
          [ngClass]="{ 'has-error': formErrors['shipDate'] }"
          (onBlur)="logValidationErrors()"
          [showOtherMonths]="true"
          [selectOtherMonths]="true"></p-date-picker>

        <span class="error-msg" *ngIf="formErrors['shipDate']">
          {{ formErrors["shipDate"] }}
        </span>
      </div>
    </div>
    <div class="col">
      <div class="form-group has-float-label">
        <!-- <input pInputText 
          jniAutoCompleteBlocker
          class="form-control"
          [min]="inHandDateCurrentdate | date: 'yyyy-MM-dd'"
          (change)="onInHandDateSelection($event)"
          onfocus="(this.type='date')"
          onblur="if(!this.value) this.type='text'"
        /> -->
        <label class="form-label"
          >In-hands date <span class="madatory-field">*</span></label
        >
        <p-date-picker
          jniAutoCompleteBlocker
          inputId="basic"
          class="date-input"
          formControlName="inHandsDate"
          (onSelect)="onInHandDateSelection($event)"
          [minDate]="inHandDateCurrentdate"
          [ngClass]="{ 'has-error': formErrors['inHandsDate'] }"
          (onBlur)="logValidationErrors()"
          [showOtherMonths]="true"
          [selectOtherMonths]="true"></p-date-picker>

        <span class="error-msg" *ngIf="formErrors['inHandsDate']">
          {{ formErrors["inHandsDate"] }}
        </span>
      </div>
    </div>
    <div class="col">
      <div class="form-group has-float-label">
        <!-- <ng-select
          class="p-0"
          id="currency"
          formControlName="methodOfPaymentHeader"
          [ngClass]="{ 'has-error': formErrors.methodOfPaymentHeader }"
          (blur)="logValidationErrors()"
          (change)="getCreditCard($event)"
        >
          <ng-option
            *ngFor="let com of customerPaymentMethodList"
            [value]="com.Name"
          >
            {{ com.Name }}
          </ng-option>
        </ng-select> -->
        <label class="form-label"
          >Method of Payment<span class="madatory-field">*</span></label
        >
        <p-select
          pInputText
          formControlName="methodOfPaymentHeader"
          [options]="customerPaymentMethodList"
          optionLabel="Name"
          optionValue="Name"
          (onChange)="getCreditCard($event)"
          [ngClass]="{ 'has-error': formErrors['methodOfPaymentHeader'] }"
          (onBlur)="logValidationErrors()"
          placeholder="Select Method of Payment">
        </p-select>

        <span class="error-msg" *ngIf="formErrors['methodOfPaymentHeader']">
          {{ formErrors["methodOfPaymentHeader"] }}
        </span>
      </div>
    </div>
    <!-- <div class="col mb-4" ngbDropdown #bc="ngbDropdown">
      <div class="form-group has-float-label">
        <input pInputText 
          jniAutoCompleteBlocker
          type="text"
          id="brandingConsultant"
          name="brandingConsultant"
          class="form-control"
          formControlName="brandingConsultant"
          (click)="onBrandingConsultantSelection(bc)"
          [ngClass]="{ 'has-error': formErrors.brandingConsultant }"
          (blur)="logValidationErrors()" />
        <label class="form-label">Branding Consultant<span class="madatory-field">*</span></label>
        <span class="error-msg" *ngIf="formErrors.brandingConsultant">
          {{ formErrors.brandingConsultant }}
        </span>
      </div>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdownBasic4"
        class="order-dropdown">
        <p-table
          #dt
          [value]="brandingConsultantLists"
          styleClass="p-datatable-customers order-listing"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="name">Project id</th>
              <th class="vaccount">Project name</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-brandingConsultantList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="onProjectIdSelection(brandingConsultantList, bc)">
              <td class="name mousepointer">
                {{ brandingConsultantList.projectId }}
              </td>
              <td class="name mousepointer">
                {{ brandingConsultantList.projectName }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No project found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div> -->
    <div class="col">
      <div class="form-group has-float-label">
        <label class="form-label"
          >Branding Consultant<span class="madatory-field">*</span></label
        >
        <input
          pInputText
          jniAutoCompleteBlocker
          type="text"
          id="brandingConsultant"
          name="brandingConsultant"
          class="form-control"
          formControlName="brandingConsultant"
          (click)="brandingPanel.toggle($event)"
          [ngClass]="{ 'has-error': formErrors['brandingConsultant'] }"
          (blur)="logValidationErrors()" />

        <span class="error-msg" *ngIf="formErrors['brandingConsultant']">
          {{ formErrors["brandingConsultant"] }}
        </span>
      </div>

      <p-overlayPanel
        #brandingPanel
        [dismissable]="true"
        [showCloseIcon]="true"
        styleClass="order-dropdown">
        <p-table
          #dt
          [value]="brandingConsultantLists"
          styleClass="p-datatable-customers order-listing"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="name">Project id</th>
              <th class="vaccount">Project name</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-brandingConsultantList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="
                onProjectIdSelection(brandingConsultantList, brandingPanel)
              ">
              <td class="name mousepointer">
                {{ brandingConsultantList.projectId }}
              </td>
              <td class="name mousepointer">
                {{ brandingConsultantList.projectName }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No project found.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-overlayPanel>
    </div>

    <div class="col">
      <div class="form-group has-float-label">
        <!-- <ng-select
          [(ngModel)]="bacUserDefaultSelectionId"
          class="p-0"
          formControlName="accountsCoordinator"
          [ngClass]="{ 'has-error': formErrors.accountsCoordinator }"
          (blur)="logValidationErrors()"
        >
          <ng-option *ngFor="let com of bacList" [value]="com.personnelNumber">
            {{ com.personnelNumber }} : {{ com.name }}
          </ng-option>
        </ng-select> -->
        <label class="form-label"
          >Accounts coordinator<span class="madatory-field">*</span></label
        >
        <p-select
          pInputText
          [(ngModel)]="bacUserDefaultSelectionId"
          formControlName="accountsCoordinator"
          [options]="bacList"
          optionLabel="name"
          optionValue="personnelNumber"
          [ngClass]="{ 'has-error': formErrors['accountsCoordinator'] }"
          (onBlur)="logValidationErrors()"
          placeholder="Select Account Coordinator">
          <ng-template let-item pTemplate="item">
            {{ item.personnelNumber }} : {{ item.name }}
          </ng-template>
        </p-select>

        <span class="error-msg" *ngIf="formErrors['accountsCoordinator']">
          {{ formErrors["accountsCoordinator"] }}
        </span>
      </div>
    </div>
  </ng-container>
</div>

<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [isFromOrdersAddNewBuyer]="true"
  [addClientContact]="addClientContact"
  [customerAccountNumber]="customerAccountNumber"
  (isContactAdded)="isContactAdded($event)"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>
